<template lang="pug">

    .ui.secondary.pointing.menu
        router-link.item(v-bind:to="offersToConfig" v-bind:exact='true') Angebote
        router-link.item(v-bind:to="addressesToConfig" v-bind:exact='true') Adressen



</template>

<script>

    export default {

        computed: {

            addressesToConfig() {
                return {
                    name: 'jobs/addresses',
                    params: {
                        jobId: this.jobModel.id,
                    }
                }
            },

            offersToConfig() {
                return {
                    name: 'jobs/update',
                    params: {
                        jobId: this.jobModel.id,
                        offerId: this.offerModel.id
                    }
                }
            }

        },

        props: {

            jobModel: {
                type: Object,
                required: true
            },

            offerModel: {
                type: Object,
                required: true
            },

        }

    }

</script>
